import React, { createContext, useContext, useMemo } from "react";
import useModelTaskListSync from "components/Modules/ModelTaskTable/hooks/useModelTaskListSync";

const noop = () => {};
const FALLBACK = { patchTask: noop, invalidate: noop };

const ModelTaskListSyncContext = createContext(FALLBACK);

/**
 * Lets an expanded task row push an edit back into the cached task list.
 *
 * The expand panel is several levels below the table and every tab needs this,
 * so it travels by context rather than through the row's prop chain.
 */
export const ModelTaskListSyncProvider = ({ modelId, children }) => {
	const { patchTask, invalidate } = useModelTaskListSync(modelId);
	const value = useMemo(
		() => ({ patchTask, invalidate }),
		[invalidate, patchTask]
	);
	return (
		<ModelTaskListSyncContext.Provider value={value}>
			{children}
		</ModelTaskListSyncContext.Provider>
	);
};

export const useModelTaskListSyncContext = () =>
	useContext(ModelTaskListSyncContext);

export default ModelTaskListSyncContext;
